import Modal  from 'bootstrap/js/dist/modal'

const $ = window.$;

$(() => {
  // Iterate over all modals to find and assign click event to all trigger elements
  $(".vetted-hs-forms").each((index, element) => {
    const $form = $(element);
    const formHash = $form.data('class');
    const $triggers = $(`.${formHash}`);

    $triggers
      .css({cursor: 'pointer'})
      .on('click', (e) => {
        e.preventDefault();
        $form.addClass('target');
        document.location.hash = formHash
      });
  })

  $('.modal-close')
    .on('click', (e) => {
      e.preventDefault();

      $(e.target)
        .closest('.vetted-hs-forms')
        .removeClass('target show');

      $("body").removeClass("modal-open").removeAttr("style");
      
      history.replaceState('', document.title, window.location.pathname);
    });
});